var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBookmark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.02344V16.5234L6 13.0234L0 16.5234V2.02344C0 1.21094 0.65625 0.523438 1.5 0.523438H10.5C11.3125 0.523438 12 1.21094 12 2.02344Z",
    fill: "#255E8E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookmark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookmark.0541af2f.svg";
export { ForwardRef as ReactComponent };